<script setup lang="ts">
import ModalFormTemplate from "../Templates/ModalFormTemplate.vue";
import DataTable from "../../table/DataTable.vue";
import { TableField } from "../../table/table";

withDefaults(
  defineProps<{
    endPoint?: string;
    customUrl?: string;
    label?: string;
    maxWidth?: string;
    size?: "sm" | "md" | "lg";
    fields: TableField[]
  }>(),
  {
    maxWidth: "100%",
    size: "md",
  }
);

const emit = defineEmits<{
  (e: "select", data: any): void;
  (e: "close"): void;
}>();

</script>

<template>
    <ModalFormTemplate
      mode="create"
      width="50rem"
      :title="label ?? null"
      :endPoint="endPoint ?? ''"
      @close="$emit('close')"
      :ignore-permission="true"
    >
      <template #form>
        <DataTable
          :title="label ?? ''"
          :fields="fields"
          :actions="[
            { name: 'select', permission: 'view', icon: 'MousePointer2', variant: 'primary', title: 'Select', visible: () => true, ignorePermission: true, hideMobile: true,},
          ]"
          :endPoint="endPoint"
          :custom-url="customUrl"
          @action="(action, data) => {
            if (action === 'select') {
              emit('select', data);
              emit('close');
            }
          }"
          @row-dbl-click="(data) => {
            emit('select', data);
            emit('close');
          }"
          :showEdit="false"
          :showDelete="false"
          :showAdd="false"
          :showSelect="true"
        />
      </template>
    </ModalFormTemplate>
</template>
